var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Tax File"}},[_c('List'),_c('Upload'),_c('Assign')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }